import {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import { subscribeToQuotaExceeded } from "./emitter";

export interface QuotaExceededPayload {
  feature: string;
  current: number;
  limit: number | null;
  overage_enabled: boolean;
  spending_cap_reached: boolean;
  upgrade_required: boolean;
}

interface LimitModalContextValue {
  payload: QuotaExceededPayload | null;
  show: (payload: QuotaExceededPayload) => void;
  hide: () => void;
}

export const LimitModalContext = createContext<LimitModalContextValue>({
  payload: null,
  show: () => {},
  hide: () => {},
});

export default function LimitModalContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [payload, setPayload] = useState<QuotaExceededPayload | null>(null);

  const show = useCallback(
    (next: QuotaExceededPayload) => setPayload(next),
    [],
  );
  const hide = useCallback(() => setPayload(null), []);

  useEffect(() => subscribeToQuotaExceeded(show), [show]);

  const value = useMemo(() => ({ payload, show, hide }), [payload, show, hide]);

  return (
    <LimitModalContext.Provider value={value}>
      {children}
    </LimitModalContext.Provider>
  );
}
